import {
  UserTrendUpIcon,
  UserGroupGlobeIcon,
  UserMessageIcon,
} from '@execonline-inc/execonline-ui';
import { Maybe, just, nothing } from 'maybeasy';

export type OfferingTypeIcon = {
  icon: typeof UserTrendUpIcon | typeof UserGroupGlobeIcon | typeof UserMessageIcon;
  color: 'teal' | 'purple';
};

export const getOfferingTypeLabel = (type: string): string => {
  switch (type?.toLowerCase()) {
    case 'aep':
      return 'On-Demand';
    case 'epc':
      return 'Professor-Led';
    case 'coaching':
      return 'Leadership Coaching';
    case 'group-coaching':
      return 'Group Coaching';
    default:
      return type || 'Course';
  }
};

export const getOfferingTypeIcon = (type: string): Maybe<OfferingTypeIcon> => {
  switch (type?.toLowerCase()) {
    case 'aep':
      return just({ icon: UserTrendUpIcon, color: 'teal' });
    case 'epc':
      return just({ icon: UserGroupGlobeIcon, color: 'purple' });
    case 'coaching':
      return just({ icon: UserMessageIcon, color: 'purple' });
    case 'group-coaching':
      return just({ icon: UserMessageIcon, color: 'purple' });
    default:
      return nothing();
  }
};
